import svgxhr from 'webpack-svgstore-plugin/src/helpers/svgxhr';
import scrollIntoView from 'scroll-into-view-if-needed';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VModal from 'vue-js-modal';
import VueWait from 'vue-wait';
import Vuetable from 'vuetable-2';
import VueTabs from 'vue-nav-tabs/dist/vue-tabs.js';
import Multiselect from 'vue-multiselect';
import vClickOutside from 'v-click-outside';
import * as VueGoogleMaps from 'vue2-google-maps';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

import './validator';
import router from './routes';
import store from './store';

// window.addEventListener('keydown', e => {
//     console.log(e.key)
// 	if(e.key === '`') {
// 		debugger;
// 	}
// });

// SVG Sprite Loader
// eslint-disable-next-line no-unused-vars
const __sprite__ = {
    path: '../../resources/images/icons/**/*.svg', //Source SVGs path relative to the compiled js (dist/js)
    name: 'images/icons.svg', //Compiled file path relative to dist/
};

NodeList.prototype.forEach = Array.prototype.forEach;

if('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
        console.log('Service worker registration succeeded:', registration);
    },function(error) {
        console.log('Service worker registration failed:', error);
    });
} else {
    console.log('Service workers are not supported.');
}

svgxhr({
    filename: 'images/icons.svg', //URL to fetch.
});

Vue.use(VueTabs);
Vue.use(Vuetable);
Vue.use(VueRouter);
Vue.use(VueWait);
Vue.use(VModal, { dialog: true, dynamic: true });
Vue.use(vClickOutside)

Vue.component('multiselect', Multiselect);

Vue.directive('tippy', {
  inserted(el, binding) {
    tippy(el, { content: binding.value })
  },
  update(el, binding) {
    // update content if binding value changes
    if (el._tippy) el._tippy.setContent(binding.value)
  },
  unbind(el) {
    if (el._tippy) el._tippy.destroy()
  }
})

const app = new Vue({
    el: '#app',
    router,
    store,
    render: (createElement) => createElement('div', {
        attrs: {
            id: 'app',
        },
    }, [
        createElement('router-view', {
            class: {
                'view': true,
            }
        }),
    ]),
    wait: new VueWait({
        useVuex: true,
    }),
    methods: {},
    created() {
        if(this.$store.getters.loggedIn) {
            this.$store.dispatch('fetchProfile').then( () => {
                // IntercomLib.loginUser(this.$store.getters.user);
            });
        } else {
            // IntercomLib.loginUnidentifiedUser();
        }
    },
});
